import useMediaQuery from '@material-ui/core/useMediaQuery';

/**
 * Équivalent à l’ancien `window.innerWidth < 450`, mais réactif au resize
 * et au changement d’orientation (MUI v4 : `breakpoints.down` n’accepte
 * pas de valeur numérique arbitraire).
 */
export default function useIsSmallScreen() {
  return useMediaQuery('(max-width:449px)');
}
